<template>
    <b-navbar toggleable="xl" :fixed=isFixed v-b-scrollspy:nav-scroller class="header-area" :class="[{'is-sticky': scrolled}]">
      <div class="container-fluid container-fluid--cp-130 scroll">
          <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
          <b-navbar-brand @click="scrollToTop" class="navbar-brand logo-light scroll" href="#">
              <img :src='"@/assets/img/pied-pro/pied-pro-logo-clean.png"' alt="logo">
          </b-navbar-brand>
          <b-navbar-brand @click="scrollToTop" v-if="!scrolled" class="navbar-brand logo-dark scroll" href="#">
              <img :src='"@/assets/img/pied-pro/pied-pro-logo-clean.png"' alt="logo">
          </b-navbar-brand>
          <b-navbar-brand @click="scrollToTop" v-if="scrolled" class="navbar-brand logo-dark scroll" href="#">
              <img :src='"@/assets/img/pied-pro/pied-pro-logo-clean.png"' alt="logo">
          </b-navbar-brand>
        <div class="content">
          <div class="row text-center" style="color: #7e7e7e">
            <div v-if="!isMobile()" class="col-12 text-center contact-info"  style="height: 65px;">
              <a href="tel:(579)640-7333" class="hover-style-link" style="font-size: 15px;">
                <i class="fas fa-phone-volume"></i>
                (579) 640-7333
              </a>
              <br>
              <a class="hover-style-link" href="https://goo.gl/maps/N3C4ibnpD8PPh4uTA" style="font-size: 15px;">
                1875 Rue Maurice-Gauvin, Laval<br>
                Suite 204 [Clinique iMSL]
<!--                <br>Laval, QC, H7S 2M5 [Clinique iMSL]-->
              </a>
            </div>
            <div v-else class="col-12  contact-info" :class="{'is-sticky': scrolled}">
              <a href="tel:(579)640-7333" class="hover-style-link" style="font-size: large;">
                <i class="fas fa-phone-volume"></i>
                (579) 640-7333
              </a>
              <br>
              <a class="hover-style-link" href="https://goo.gl/maps/N3C4ibnpD8PPh4uTA">
                1875 Rue Maurice-Gauvin, Suite 204
                <br>Laval, QC, H7S 2M5 [Clinique iMSL]
              </a>
            </div>
          </div>
          <div class="row">
            <b-collapse class="default-nav justify-content-center" is-nav id="nav_collapse">
              <b-navbar-nav class="navbar-nav main-menu">
                <b-nav-item @click="scrollToTop" href="#acceuil" class="scroll"><span>ACCUEIL</span></b-nav-item>
                <b-nav-item @click="scrollToTop" href="#services" class="scroll"><span>SERVICES</span></b-nav-item>
                <b-nav-item @click="scrollToTop" href="#equipe" class="scroll"><span>EQUIPE</span></b-nav-item>
                <b-nav-item @click="scrollToTop" href="#contact" class="scroll"><span>NOUS JOINDRE</span></b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </div>
        </div>
        <b-btn-group class="header-config-wrapper">
          <b-link class="ht-btn hire-btn d-xl-block btn-appointment"
                  @click="toggleClass('addClass', 'active')">
            Prendre rendez-vous
          </b-link>
        </b-btn-group>
      </div>

<!--      &lt;!&ndash; MODAL &ndash;&gt;-->
<!--      <div>-->
<!--        <b-modal id="modal-RDZ-header" class="modal-backdrop" size="xl" title="Réservez votre prochaine date approximative souhaitée."-->
<!--                 :hide-footer="true">-->
<!--            <CalendarDentiste></CalendarDentiste>-->
<!--        </b-modal>-->
<!--      </div>-->

    </b-navbar>
</template>

<script>
import {VBScrollspy} from "bootstrap-vue"
// import CalendarDentiste from "@/components/cliniqueDentaire/CalendarDentiste";
    export default {
        name:'HeaderPiedProd',
        directives:{
          'b-scrollspy' : VBScrollspy
        },
        components: {
          // CalendarDentiste
        },
        props:{
            scrolled: {
              type: Boolean,
              default: false
            },
            isFixed: {
              type: String,
              default: "top"
            },
            isAdPage: {
                type: Boolean,
                default: false
            },
            isColorWhite: {
                type: Boolean,
                default: false
            }
        },
        data (){
            return {
                load: false,
                limitPosition: 200,
                // scrolled: false,
                lastPosition: 500,
            }
        },
        mounted (){
            (function() {
                scrollTo();
            })();

            function scrollTo() {
                const links = document.querySelectorAll('.scroll > a');
                links.forEach(each => (each.onclick = scrollAnchors));
            }

            function scrollAnchors(e, respond = null) {
                const distanceToTop = el => Math.floor(el.getBoundingClientRect().top) - 180;
                e.preventDefault();
                var targetID = (respond) ? respond.getAttribute('href') : this.getAttribute('href');
                const targetAnchor = document.querySelector(targetID);
                if (!targetAnchor) return;
                const originalTop = distanceToTop(targetAnchor);
                window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
                const checkIfDone = setInterval(function() {
                    const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 190;
                    if (distanceToTop(targetAnchor) === 0 || atBottom) {
                        targetAnchor.tabIndex = '-1';
                        targetAnchor.focus();
                        //window.history.pushState('', '', targetID);
                        clearInterval(checkIfDone);
                    }
                }, 800);
            }
        },
        methods: {
            // sticky menu script
            handleScroll() {
                if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
                    this.scrolled = true;
                    // move up!
                } 
                
                if (this.lastPosition > window.scrollY) {
                    this.scrolled = true;
                    // move down
                }
                
                this.lastPosition = window.scrollY;
                this.scrolled = window.scrollY > 50;
            },
            scrollToTop() {
                if( this.isAdPage ) {
                  this.$router.push({ path: '/'})
                }
                else {
                  window.scrollTo(0,0);
                }
            },
            // offcanvas searchbox
            toggleClass(addRemoveClass, className) {
                const el = document.querySelector('#search-overlay');
                if (addRemoveClass === 'addClass') {
                  el.classList.add(className);
                } else {
                  el.classList.remove(className);
                }
            },
            isMobile() {
                if( screen.width <= 760 ) {
                    return true;
                }
                else {
                    return false;
                }
            }
        }, 
        created() {
            window.addEventListener("scroll", this.handleScroll);
        },
        destroyed() {
            window.removeEventListener("scroll", this.handleScroll);
        },
    }
</script>